// @flow

import justlease from './justlease.theme';

export const globalCss = '';

export default justlease;
